export interface AICreator {
  id: string;
  slug: string;
  name: string;
  role: string;
  avatar: string;
  coverImage: string;
  verified: boolean;
  followers: string;
  bio: string;
  projects: number;
  tools: string[];
  featuredWork: string;
  featuredProjectId: number;
  category: string;
  country: string;
}

export const aiCreators: AICreator[] = [
  {
    id: 'ai-creator-001',
    slug: 'alex-chen-ai-filmmaker',
    name: 'Alex Chen',
    role: 'AI Filmmaker',
    avatar: 'https://public.readdy.ai/ai/img_res/0efe860d074069c084145b396bd20417.jpg',
    coverImage: 'https://readdy.ai/api/search-image?query=Futuristic%20AI%20filmmaking%20studio%20with%20holographic%20screens%20and%20neon%20lighting%20cyberpunk%20creative%20workspace%20with%20advanced%20technology%20and%20cinematic%20equipment%20dark%20moody%20atmosphere&width=800&height=300&seq=ai-creator1-cover&orientation=landscape',
    verified: true,
    followers: '45.2K',
    bio: 'AI filmmaker and creative technologist. Pushing the boundaries of AI-generated cinema since 2023.',
    projects: 3,
    tools: ['Runway Gen-4', 'ElevenLabs', 'Midjourney V6', 'Suno AI', 'GPT-4'],
    featuredWork: 'The Last Algorithm',
    featuredProjectId: 1,
    category: 'Sci-Fi',
    country: 'USA'
  },
  {
    id: 'ai-creator-002',
    slug: 'fatima-al-hassan-ai-storyteller',
    name: 'Fatima Al-Hassan',
    role: 'AI Visual Storyteller',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20elegant%20Middle%20Eastern%20woman%20filmmaker%20with%20artistic%20styling%20warm%20ambient%20lighting%20creative%20professional%20photography&width=200&height=200&seq=ai-creator2-lg&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=Cinematic%20desert%20landscape%20at%20golden%20hour%20with%20mysterious%20ancient%20ruins%20dramatic%20shadows%20and%20warm%20orange%20tones%20epic%20movie%20scene%20quality%20AI%20generated%20drama%20visual&width=800&height=300&seq=ai-creator2-cover&orientation=landscape',
    verified: true,
    followers: '32.1K',
    bio: 'Visual storyteller blending ancient narratives with cutting-edge AI technology. Based in Dubai.',
    projects: 2,
    tools: ['Sora', 'Udio', 'Stable Diffusion XL', 'Adobe Firefly'],
    featuredWork: 'Whispers in the Sand',
    featuredProjectId: 2,
    category: 'Drama',
    country: 'UAE'
  },
  {
    id: 'ai-creator-003',
    slug: 'marcus-webb-ai-comedy',
    name: 'Marcus Webb',
    role: 'AI Comedy Creator',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20Black%20male%20content%20creator%20with%20stylish%20glasses%20modern%20casual%20outfit%20bright%20studio%20lighting%20friendly%20expression&width=200&height=200&seq=ai-creator3-lg&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20creative%20comedy%20studio%20with%20colorful%20lighting%20and%20fun%20atmosphere%20digital%20content%20creation%20workspace%20with%20screens%20showing%20comedic%20scenes%20warm%20inviting%20environment&width=800&height=300&seq=ai-creator3-cover&orientation=landscape',
    verified: true,
    followers: '28.7K',
    bio: 'Comedy writer turned AI filmmaker. Making people laugh one generated frame at a time.',
    projects: 1,
    tools: ['Pika Labs', 'ChatGPT', 'Runway Gen-3', 'ElevenLabs'],
    featuredWork: 'Error 404: Love Not Found',
    featuredProjectId: 3,
    category: 'Comedy',
    country: 'UK'
  },
  {
    id: 'ai-creator-004',
    slug: 'yuki-tanaka-ai-thriller',
    name: 'Yuki Tanaka',
    role: 'AI Thriller Director',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Japanese%20woman%20digital%20artist%20with%20creative%20makeup%20artistic%20lighting%20modern%20fashion%20photography%20style&width=200&height=200&seq=ai-creator4-lg&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20atmospheric%20film%20noir%20studio%20with%20dramatic%20shadows%20and%20moody%20blue%20lighting%20psychological%20thriller%20aesthetic%20creative%20workspace%20with%20mysterious%20ambiance&width=800&height=300&seq=ai-creator4-cover&orientation=landscape',
    verified: true,
    followers: '67.4K',
    bio: 'Digital artist and psychological thriller enthusiast. Exploring the dark side of AI through visual storytelling.',
    projects: 2,
    tools: ['Runway Gen-4', 'Midjourney V6', 'Suno AI', 'Topaz Video AI'],
    featuredWork: 'The Mirror Protocol',
    featuredProjectId: 4,
    category: 'Thriller',
    country: 'Japan'
  },
  {
    id: 'ai-creator-005',
    slug: 'kenji-nakamura-ai-anime',
    name: 'Kenji Nakamura',
    role: 'AI Anime Creator',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Japanese%20male%20animator%20with%20creative%20styling%20artistic%20studio%20lighting%20modern%20fashion&width=200&height=200&seq=ai-creator5-lg&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=Vibrant%20anime%20style%20cyberpunk%20creative%20studio%20with%20neon%20lights%20and%20digital%20art%20displays%20Japanese%20animation%20production%20workspace%20with%20colorful%20screens%20and%20artistic%20atmosphere&width=800&height=300&seq=ai-creator5-cover&orientation=landscape',
    verified: true,
    followers: '89.3K',
    bio: 'Anime-inspired AI filmmaker. Bringing cyberpunk visions to life with cutting-edge generation tools.',
    projects: 4,
    tools: ['Kling AI', 'Midjourney V6', 'ElevenLabs', 'Suno AI', 'ComfyUI'],
    featuredWork: 'Neon Samurai',
    featuredProjectId: 5,
    category: 'Action',
    country: 'Japan'
  },
  {
    id: 'ai-creator-006',
    slug: 'omar-rashid-ai-drama',
    name: 'Omar Rashid',
    role: 'AI Drama Creator',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Middle%20Eastern%20male%20filmmaker%20with%20beard%20sophisticated%20styling%20warm%20studio%20lighting%20confident%20creative%20professional&width=200&height=200&seq=ai-creator6-lg&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=Luxurious%20Middle%20Eastern%20mansion%20interior%20with%20warm%20golden%20lighting%20elegant%20decor%20and%20cinematic%20atmosphere%20professional%20drama%20production%20environment%20with%20rich%20cultural%20details&width=800&height=300&seq=ai-creator6-cover&orientation=landscape',
    verified: true,
    followers: '54.6K',
    bio: 'Award-winning AI drama creator specializing in family narratives and cultural storytelling.',
    projects: 3,
    tools: ['Sora', 'ElevenLabs', 'Runway Gen-4', 'GPT-4'],
    featuredWork: 'The Inheritance',
    featuredProjectId: 6,
    category: 'Drama',
    country: 'UAE'
  },
  {
    id: 'ai-creator-007',
    slug: 'layla-ibrahim-ai-romance',
    name: 'Layla Ibrahim',
    role: 'AI Romance Director',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Egyptian%20woman%20filmmaker%20with%20elegant%20styling%20warm%20ambient%20lighting%20creative%20professional%20photography&width=200&height=200&seq=ai-creator8-lg&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20historic%20Cairo%20streets%20at%20night%20with%20warm%20lantern%20lighting%20ancient%20architecture%20and%20mysterious%20atmosphere%20cinematic%20quality%20beautiful%20cultural%20setting&width=800&height=300&seq=ai-creator7-cover&orientation=landscape',
    verified: true,
    followers: '38.9K',
    bio: 'Egyptian filmmaker bringing romantic stories to life through AI. Passionate about preserving cultural narratives.',
    projects: 2,
    tools: ['Runway Gen-4', 'Suno AI', 'Midjourney V6', 'ElevenLabs'],
    featuredWork: 'Midnight in Cairo',
    featuredProjectId: 8,
    category: 'Romance',
    country: 'Egypt'
  },
  {
    id: 'ai-creator-008',
    slug: 'james-morrison-ai-horror',
    name: 'James Morrison',
    role: 'AI Horror Filmmaker',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20British%20male%20horror%20filmmaker%20with%20dark%20artistic%20styling%20dramatic%20lighting%20creative%20industry%20photography&width=200&height=200&seq=ai-creator9-lg&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20abandoned%20Victorian%20mansion%20interior%20with%20eerie%20shadows%20creeping%20fog%20and%20supernatural%20atmosphere%20horror%20film%20production%20set%20with%20dramatic%20moody%20lighting&width=800&height=300&seq=ai-creator8-cover&orientation=landscape',
    verified: true,
    followers: '76.2K',
    bio: 'Horror filmmaker and AI pioneer. Creating nightmares you can\'t look away from.',
    projects: 3,
    tools: ['Runway Gen-4', 'ElevenLabs', 'Stable Video', 'Midjourney V6'],
    featuredWork: 'The Hollow',
    featuredProjectId: 9,
    category: 'Horror',
    country: 'UK'
  },
  {
    id: 'ai-creator-009',
    slug: 'david-kim-ai-action',
    name: 'David Kim',
    role: 'AI Action Director',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Korean%20American%20male%20filmmaker%20with%20modern%20styling%20professional%20studio%20lighting%20confident%20expression&width=200&height=200&seq=ai-creator11-lg&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20battle%20scene%20production%20studio%20with%20giant%20screens%20showing%20mecha%20robots%20and%20futuristic%20military%20vehicles%20dramatic%20lighting%20professional%20VFX%20workspace&width=800&height=300&seq=ai-creator9-cover&orientation=landscape',
    verified: true,
    followers: '112.8K',
    bio: 'Action filmmaker and VFX enthusiast. Creating blockbuster-quality AI films from my apartment.',
    projects: 5,
    tools: ['Sora', 'Runway Gen-4', 'ElevenLabs', 'Suno AI', 'Unreal Engine'],
    featuredWork: 'Rise of the Machines',
    featuredProjectId: 11,
    category: 'Action',
    country: 'USA'
  },
  {
    id: 'ai-creator-010',
    slug: 'chris-taylor-ai-comedy',
    name: 'Chris Taylor',
    role: 'AI Comedy Producer',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20British%20male%20comedian%20with%20friendly%20expression%20casual%20styling%20bright%20studio%20lighting&width=200&height=200&seq=ai-creator12-lg&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=Colorful%20comedy%20show%20stage%20with%20spotlight%20and%20vibrant%20lighting%20entertainment%20venue%20with%20modern%20creative%20atmosphere%20fun%20energetic%20production%20environment&width=800&height=300&seq=ai-creator10-cover&orientation=landscape',
    verified: true,
    followers: '67.5K',
    bio: 'Stand-up comedian exploring the hilarious side of AI. If robots can be funny, we\'re all in trouble.',
    projects: 2,
    tools: ['Pika Labs', 'ElevenLabs', 'ChatGPT', 'Runway Gen-3'],
    featuredWork: 'The AI Comedian',
    featuredProjectId: 12,
    category: 'Comedy',
    country: 'UK'
  },
  {
    id: 'ai-creator-011',
    slug: 'elena-volkov-ai-experimental',
    name: 'Elena Volkov',
    role: 'AI Experimental Artist',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Eastern%20European%20woman%20experimental%20filmmaker%20with%20artistic%20expression%20dramatic%20lighting%20creative%20industry%20photography&width=200&height=200&seq=ai-creator7-lg&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=Abstract%20experimental%20art%20studio%20with%20surreal%20floating%20geometric%20shapes%20and%20vibrant%20colors%20dreamlike%20atmosphere%20avant-garde%20creative%20workspace%20with%20artistic%20installations&width=800&height=300&seq=ai-creator11-cover&orientation=landscape',
    verified: false,
    followers: '12.3K',
    bio: 'Experimental filmmaker exploring the intersection of AI, consciousness, and abstract visual art.',
    projects: 1,
    tools: ['Deforum', 'TouchDesigner', 'Stable Diffusion', 'Udio'],
    featuredWork: 'Fragments of Tomorrow',
    featuredProjectId: 7,
    category: 'Experimental',
    country: 'Russia'
  },
  {
    id: 'ai-creator-012',
    slug: 'sofia-martinez-ai-visual',
    name: 'Sofia Martinez',
    role: 'AI Visual Artist',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Latina%20woman%20digital%20artist%20with%20colorful%20creative%20styling%20bright%20studio%20lighting%20artistic%20expression&width=200&height=200&seq=ai-creator10-lg&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=Surreal%20dreamscape%20creative%20studio%20with%20floating%20islands%20and%20bioluminescent%20elements%20soft%20pastel%20colors%20ethereal%20atmosphere%20fantasy%20world%20artistic%20workspace&width=800&height=300&seq=ai-creator12-cover&orientation=landscape',
    verified: false,
    followers: '23.4K',
    bio: 'Visual artist and dreamer. Creating worlds that exist between sleep and waking.',
    projects: 1,
    tools: ['Luma Dream Machine', 'Midjourney V6', 'Udio', 'After Effects'],
    featuredWork: 'Digital Dreams',
    featuredProjectId: 10,
    category: 'Experimental',
    country: 'Mexico'
  }
];
